import React from 'react';
import { getStatusStyle } from '../tokens';

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Semantic status key — auto-picks color. Can also pass custom label via children. */
  status?: string;
  /** Whether to show a pulsing dot prefix. */
  pulse?: boolean;
  /** Override the label; by default uses Hebrew label from status map. */
  children?: React.ReactNode;
  size?: 'sm' | 'md';
}

export const Badge: React.FC<BadgeProps> = ({
  status = 'open',
  pulse,
  children,
  size = 'sm',
  className = '',
  ...rest
}) => {
  const style = getStatusStyle(status);
  const sizeClasses = size === 'sm'
    ? 'text-[10px] px-2 py-0.5'
    : 'text-xs px-2.5 py-1';

  return (
    <span
      className={[
        'inline-flex items-center gap-1.5 rounded-full font-bold uppercase tracking-widest whitespace-nowrap',
        style.bg,
        style.text,
        sizeClasses,
        className,
      ].join(' ')}
      {...rest}
    >
      {pulse ? (
        <span className="relative flex h-1.5 w-1.5">
          <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${style.dot} opacity-75`} />
          <span className={`relative inline-flex rounded-full h-1.5 w-1.5 ${style.dot}`} />
        </span>
      ) : (
        <span className={`size-1.5 rounded-full ${style.dot}`} />
      )}
      {children || style.label}
    </span>
  );
};
